import React, { lazy, Suspense } from 'react';
import { Outlet, RouteObject } from 'react-router-dom';
import { NavConfig } from '../../data/constants/nav';

const OktaSecurity = lazy(() => import('../login/OktaSecurity'));
const Login = lazy(() => import('../login/Login'));
const LoginCallback = lazy(() => import('../login/LoginCallback'));

const loginRoutes: RouteObject[] = [
  {
    path: NavConfig.loginConfig.loginPath,
    element: (
      <OktaSecurity>
        <Suspense>
          <Outlet />
        </Suspense>
      </OktaSecurity>
    ),
    children: [
      {
        index: true,
        element: <Login />,
      },
      {
        path: NavConfig.loginConfig.loginCallbackPath,
        element: <LoginCallback />,
      },
    ],
  },
];

export default loginRoutes;
